import React, { FunctionComponent, useEffect } from 'react';
import 'antd/dist/antd.min.css';
import './styles/main.scss';
import { Routes, Route } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import Header from './components/Header';
import DashboardPage from './pages/DashboardPage';
import OverviewPage from './pages/OverviewPage';
import { useSelector } from 'react-redux';
import { TStore, useAppDispatch } from './store';
import { logout } from "./slices/authSlice";
import { getStrainData } from './actions/strainAction';
import { getRecoveryData } from './actions/recoveryAction';
import Login from './components/auth/Login';
import { ProtectedRoute } from './components/ProtectedRoute';
import Strain from './components/Strain';
import Recovery from './components/Recovery';
import Sleep from './components/Sleep';

const App: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const { userToken } = useSelector((state: TStore) => state.user);
  const { error: strainError } = useSelector((state: TStore) => state.strain);
  const { error: recoveryError } = useSelector((state: TStore) => state.recovery);
  const navigate = useNavigate();

  useEffect(() => {
    if (userToken) {
      dispatch(getStrainData(1));
      dispatch(getRecoveryData(1));
      if (strainError || recoveryError) {
        if (strainError?.includes("401") || recoveryError?.includes("401")) {
          dispatch(logout());
        }
      }
    } else {
      navigate("/login")
    }
  }, [userToken]);

  return (
    <>
      {
        userToken ?
        <div className="body">
        <Header />
          <Routes>
            <Route key="home" path="/" element={<ProtectedRoute><OverviewPage /></ProtectedRoute>} />
            <Route key="dashboard" path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route key="strain" path="/strain" element={<ProtectedRoute><Strain /></ProtectedRoute>} />
            <Route key="recovery" path="/recovery" element={<ProtectedRoute><Recovery /></ProtectedRoute>} />
            <Route key="sleep" path="/sleep" element={<ProtectedRoute><Sleep /></ProtectedRoute>} />
            <Route path="/login" element={<Login />} />
          </Routes>
        </div>
        :
        <Login />
      }
    </>
  );
};

export default App;
